"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const React = __importStar(require("react"));
const core_1 = require("@emotion/core");
const helper_1 = require("orbiter-core-planner/lib/helper");
const Slot_1 = __importDefault(require("./Slot"));
class Moment extends React.Component {
    renderSlot(s, i) {
        return this.props.renderSlot ? this.props.renderSlot(s, i) : core_1.jsx(Slot_1.default, { buttonStyle: this.props.buttonStyle, onClick: () => this.props.onSelect(s), key: i, range: s.toTimeSlot() });
    }
    render() {
        const modifiedStyle = (theme) => {
            return core_1.css `
                margin: 10px;
                p{
                    margin: 0;
                }
                i{
                    display: inline-block;
                    opacity: 0.5;
                    margin-top: 40px;
                }
            `;
        };
        const renders = this.props.slots.length === 0 ? core_1.jsx("p", null,
            core_1.jsx("i", null, "Geen vrije momenten.")) : this.props.slots.map((s, i) => {
            return this.renderSlot(s, i);
        });
        return (core_1.jsx("div", { css: (t) => {
                return [modifiedStyle(t), this.props.modifiedStyle !== undefined ? this.props.modifiedStyle(t) : undefined];
            } },
            core_1.jsx("p", null,
                core_1.jsx("b", null, helper_1.momentToDayOfWeek(this.props.day))),
            core_1.jsx("p", null,
                this.props.day.format("D"),
                " ",
                helper_1.momentToMonth(this.props.day),
                " ",
                this.props.day.format("YYYY")),
            core_1.jsx("div", null,
                renders,
                this.props.appendedDayContent ? this.props.appendedDayContent(this.props.day) : undefined)));
    }
}
exports.default = Moment;
//# sourceMappingURL=Day.js.map